import { render, staticRenderFns } from "./_productCard.vue?vue&type=template&id=0a1d2866&scoped=true"
import script from "./_productCard.vue?vue&type=script&lang=js"
export * from "./_productCard.vue?vue&type=script&lang=js"
import style0 from "./_productCard.vue?vue&type=style&index=0&id=0a1d2866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1d2866",
  null
  
)

export default component.exports